<template>
	<CDialog
		id="delete-email-domain-dialog"
		:visible="visible"
		title="Delete Email Domain?"
		custom-class="dialog--narrow"
		@done="$emit('close')"
	>
		<p class="c-delete-confirm-msg">Are you sure you want to delete this email domain?</p>
		<template #footer>
			<button
				class="c-modal-button c-modal-button-cancel button--secondary"
				@click="$emit('close')"
			>
				Cancel
			</button>
			<button
				class="c-modal-button button--primary"
				:class="{'c-button-executing': executing}"
				@click="executing = true; $emit('delete', domainName)"
			>
				Delete
			</button>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import { defineComponent, ref, watch } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';

	export default defineComponent({
		name: 'CDeleteEmailDomainDialog',
		components: {
			CDialog
		},
		props: {
			domainName: { type: String, required: true },
			visible: { type: Boolean, default: false }
		},
		emit: ['delete', 'close'],
		setup(props) {
			const executing = ref(false);

			watch(() => props.visible, () => {
				executing.value = false;
			});
			return {
				executing
			};
		}
	});
</script>